import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';

const Header: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header>
      <div className="header-brand">
        <img src="/logo.svg" alt="Logo" className="header-logo" />
      </div>
      <nav>
        <Link to="/" className={isActive('/')}>
          Home
        </Link>
        <Link to="/annuity-calculator" className={isActive('/annuity-calculator')}>
          Annuïteiten Calculator
        </Link>
        <Link to="/linear-calculator" className={isActive('/linear-calculator')}>
          Lineaire Calculator
        </Link>
        <Link to="/interest-rates" className={isActive('/interest-rates')}>
          Rente Grafieken
        </Link>
        <Link to="/contact" className={isActive('/contact')}>
          Contact
        </Link>
        <button
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={isDark ? 'Schakel naar lichte modus' : 'Schakel naar donkere modus'}
        >
          {isDark ? '☀️' : '🌙'}
          {isDark ? 'Licht' : 'Donker'}
        </button>
      </nav>
    </header>
  );
};

export default Header;
